import { http } from './http';
import type { AuthUser } from '@/store/authStore';

export interface LoginResponse {
  token: string;
  expiresAt: string;
  user: AuthUser;
}

export const authApi = {
  login: (username: string, password: string) =>
    http.post<LoginResponse>('/auth/login', { username, password }).then((r) => r.data),

  me: () => http.get<{ id: string; login: string; roles: string[] }>('/auth/me').then((r) => r.data),
};
